import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { NoAppAccess } from './NoAppAccess';

/**
 * Route guard that requires the user to be authenticated.
 * Redirects to /login if not authenticated, preserving the intended destination.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.surfaceAccess && user.surfaceAccess !== 'allowed') return <NoAppAccess />;

  return <Outlet />;
}
